import { useContext } from 'react'

import { RequisitionOriginContext } from '@/modules/requisitions/context/requisitionOriginContextDef'

export function useRequisitionOriginContext() {
  return useContext(RequisitionOriginContext)
}
